import { IonContent, IonHeader, IonPage } from "@ionic/react";
import UserCard from "../components/card/UserCard";
import Header from "../components/layout/Header";
import { useState, useEffect } from "react";
import { getAllProfiles } from "../api/requests/profile";
import { Helmet } from "react-helmet-async";

const Friends = () => {
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    getAllProfiles().then((res) => {
      if (res.data) {
        setAllUsers(res.data);
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>
        <IonContent>
          <div className="display-flex flex-direction-c">
            {allUsers.map((user) => (
              <UserCard key={user._id} user={user} />
            ))}
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default Friends;
